import * as React from 'react'

import { List, useTranslate } from 'react-admin'

import { PaymentActions } from '../actions/paymentActions'
import { CollectionDatagrid } from '../datagrids/collectionDatagrid'
import { CollectionEmpty } from '../emptyViews/collectionEmptyView'
import { Pagination } from './pagination'
import PanelHeader from 'components/PanelHeader'

const SORT = {
  field: 'deposited_at',
  order: 'DESC',
}

const CollectionPagination = (props) => {
  return <Pagination {...props} rowsPerPageOptions={[10, 25, 50, 100]} />
}

export const CollectionList = (props) => {
  return <CollectionListCore {...props} />
}

export const CollectionListCore = ({
  className,
  hasList,
  hasShow,
  hasEdit,
  ...props
}) => {
  const translate = useTranslate()
  const [showExport, setShowExport] = React.useState(false)

  const handleChangeList = ({ total, loading }) => {
    setShowExport(!loading && total > 0)
  }

  return (
    <>
      <PanelHeader title={translate('resources.payments.name')} />
      <List
        className={className}
        {...props}
        hasList={hasList}
        hasShow={hasShow}
        hasEdit={hasEdit}
        bulkActionButtons={false}
        actions={<PaymentActions {...props} showExport={showExport} />}
        pagination={<CollectionPagination />}
        empty={<CollectionEmpty {...props} onChangeList={handleChangeList} />}
        title={translate('resources.payments.name')}
        sort={SORT}
      >
        <CollectionDatagrid {...props} onChangeList={handleChangeList} />
      </List>
    </>
  )
}
